import React, { useState, useCallback } from 'react';
import PropTypes, { object } from 'prop-types';

import { Container as DraggableContainer, Draggable } from 'react-smooth-dnd';

import { questionFieldName } from '../../formFields';
import AddButtons from '../AddButtons';
import QuestionStep from '../QuestionStep';
import ConfirmDialog from '../../../ConfirmDialog';

import { StyledFieldArray } from './styles';
import texts from './texts.json';

const FormQuestions = ({
  questions,
  fieldName,
  addOptions,
  elementArray,
  draggable,
  formType,
  isCoachView,
}) => {
  const [pendingRemoveIndex, setPendingRemoveIndex] = useState(null);

  const handleRemoveRequest = useCallback((index) => {
    if (isCoachView) {
      setPendingRemoveIndex(index);
    }
  }, [isCoachView]);

  const handleConfirmRemove = useCallback((remove) => {
    remove(pendingRemoveIndex);
    setPendingRemoveIndex(null);
  }, [pendingRemoveIndex]);

  const handleCancelRemove = useCallback(() => {
    setPendingRemoveIndex(null);
  }, []);

  return (
    <StyledFieldArray
      name={fieldName}
      render={({
        remove,
        push,
        move,
      }) => (
        <>
          {questions.length > 0
          && (
            <DraggableContainer
              dragHandleSelector=".drag-handle"
              lockAxis="y"
              onDrop={({ removedIndex, addedIndex }) => move(removedIndex, addedIndex)}
            >
              {questions.map((question, index) => (
                // TODO: Change the key of the draggable to an actual ID (S2-2078)
                // eslint-disable-next-line react/no-array-index-key
                <Draggable key={index}>
                  <QuestionStep
                    question={question}
                    removeRow={isCoachView ? () => handleRemoveRequest(index) : () => remove(index)}
                    draggable={draggable}
                    Component={elementArray[question[questionFieldName.TYPE]]}
                    extraProps={{ index, formType }}
                    isCoachView={isCoachView}
                    formType={formType}
                  />
                </Draggable>
              ))}
            </DraggableContainer>
          )}
          <AddButtons
            push={(question) => {
              push(question);
            }}
            options={addOptions}
          />

          <ConfirmDialog
            isOpen={pendingRemoveIndex !== null}
            onConfirm={() => handleConfirmRemove(remove)}
            onCancel={handleCancelRemove}
            dialogTexts={texts.deleteDialog}
          />
        </>
      )}
    />
  );
};

FormQuestions.propTypes = {
  questions: PropTypes.arrayOf(object),
  fieldName: PropTypes.string.isRequired,
  addOptions: PropTypes.array,
  elementArray: PropTypes.object.isRequired,
  draggable: PropTypes.bool,
  formType: PropTypes.string.isRequired,
  isCoachView: PropTypes.bool,
};

FormQuestions.defaultProps = {
  questions: [],
  addOptions: [],
  draggable: true,
  isCoachView: false,
};

export default FormQuestions;
